module.exports = __webpack_public_path__ + "img/jwwl.c1559681.jpg";